import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Avatar, Box, Card, Chip, IconButton, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import {
  BIGreen,
  BIGrey,
  BILightGreen,
  BILightGrey,
  BILightYellow,
  BIYellow
} from "../../assets/helpers";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_SUPPORT, FETCH_CLIENT_SUPPORT_2 } from "../../constant/Apipath";
import { useLocation, useNavigate } from "react-router-dom";
import AddClientSupport from "./ClientSupportAddModal";
import ViewClientSupport from "./ClientSupportViewModal";
import TabsComponent from "../component/TabsComponent";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import InfiniteScroll from "react-infinite-scroll-component";

function ClientSupport() {
  const location = useLocation();
  const dataId = location.state?.id;
  const custom = location.state?.custom;
  const navigate = useNavigate();

  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const { selectedClientData } = useSelector((state) => state?.main);

  const [supportData, setSupportData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState(0);
  const [viewSupport, setViewSupport] = useState(false);
  const [supportId, setSupportId] = useState(0);
  const [viewAddModel, setViewAddModel] = useState(false);
  const [loadNew, setLoadNew] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const LANGUAGE = ClientEnglishFallback.ClientSupport(multiLanguageData?.ClientSupport || {});
  const {
    TEXT_SEARCH_NO_SUPPORT_REQUESTS_PLACE_HOLDER,
    TEXT_ALL,
    TEXT_OPEN,
    TEXT_COMPLETED,
    TEXT_CLOSED
  } = LANGUAGE;

  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    if (typeof dataId === "number") {
      handleShowViewModel(dataId);
    }
    const callInitialdata = async () => {
      setIsLoading(true);
      await getSupportData(1);
      setIsLoading(false);
    };
    callInitialdata();
  }, [currentTab, location]);

  const getSupportData = async (pageNo) => {
    try {
      const obj = {
        PageNr: pageNo,
        NrOfRecPerPage: 20,
        FullSearch: location?.state?.searchText || "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientId: selectedClientData?.ClientId,
            clientEmployeeId: selectedClientData?.ClientEmployeeId,
            status: getStatus()
          }
        ],
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ]
      };
      const supportResponse = await Postrequestcall(
        FETCH_CLIENT_SUPPORT_2,
        obj,
        loginData?.accessToken
      );
      if (supportResponse?.status === 200) {
        if (pageNo === 1) {
          setSupportData(supportResponse?.data?.data);
        } else {
          setSupportData((prevData) => [...prevData, ...supportResponse?.data?.data]);
        }
        setPageNo(pageNo + 1);
        if (supportResponse?.data?.data?.length === 0) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      } else {
        setSupportData([]);
      }
    } catch (error) {
      setSupportData([]);
      console.log("getSupportData-> Error Getting Support Data: ", error);
    }
  };

  const getStatus = () => {
    switch (currentTab) {
      case 0:
        return "";
      case 1:
        return "Open";
      case 2:
        return "Completed";
      case 3:
        return "Closed";
      default:
        return "Unknown";
    }
  };

  const getBgColor = (status) => {
    switch (status) {
      case "Open":
        return BILightGrey;
      case "Closed":
        return BILightGreen;
      case "Completed":
        return BILightYellow;
      default:
        return BILightGrey;
    }
  };
  const getColor = (status) => {
    switch (status) {
      case "Open":
        return BIGrey;
      case "Closed":
        return BIGreen;
      case "Completed":
        return BIYellow;
      default:
        return BIGrey;
    }
  };

  const handleShowViewModel = (id) => {
    setViewSupport(true);
    setSupportId(id);
  };

  const handleHideViewModel = async () => {
    if (typeof dataId === "number") {
      navigate("", { replace: true });
    }
    setViewSupport(false);
    setSupportId(0);
    if (loadNew) {
      setIsLoading(true);
      await getSupportData(1);
      setIsLoading(false);
      setLoadNew(false);
    }
  };

  const handleToggleAddModel = async (loadNew) => {
    setViewAddModel(!viewAddModel);
    if (loadNew === true) {
      setIsLoading(true);
      await getSupportData(1);
      setIsLoading(false);
      setLoadNew(false);
    }
  };

  const CustomListing = ({ data, index }) => {
    return (
      <Card
        key={index}
        sx={{
          padding: 2,
          marginBottom: 2,
          boxShadow: "none",
          cursor: "pointer ",
          borderRadius: "10px"
        }}
        onClick={() => handleShowViewModel(data?.id)}>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
            <Stack direction="row" alignItems="center" spacing={1}>
              <Avatar src={data?.userProfilePicture} />
              <Typography variant="body1">{data?.clientEmployeeName}</Typography>
            </Stack>
            <Typography variant="body1" style={{ color: BIGrey }}>
              {dayjs(data?.dateSubmitted).format("MMMM DD, YYYY")}
            </Typography>
          </Stack>
          <Typography variant="body1">{data?.description}</Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent={data?.supportCategoryName ? "space-between" : "flex-end"}
          spacing={1}
          paddingBottom={"0px"}>
          {data?.supportCategoryName && (
            <Chip sx={{ borderRadius: "6px" }} label={data?.supportCategoryName} />
          )}
          <Chip
            label={data?.status}
            sx={{
              backgroundColor: getBgColor(data?.status),
              color: getColor(data?.status)
            }}
          />
        </Stack>
      </Card>
    );
  };

  const Tabs = [
    {
      label: "All",
      value: 0,
      translateLabel: TEXT_ALL
    },
    {
      label: "Open",
      value: 1,
      translateLabel: TEXT_OPEN
    },
    {
      label: "Completed",
      value: 2,
      translateLabel: TEXT_COMPLETED
    },
    {
      label: "Closed",
      value: 3,
      translateLabel: TEXT_CLOSED
    }
  ];

  return (
    <>
      <Box>
        <TabsComponent tabs={Tabs} setTabsValue={setCurrentTab} tabValue={currentTab} />
        {isLoading ? (
          <>{dataId ? <></> : <Loader fullScreen />}</>
        ) : supportData?.length > 0 ? (
          <div
            id="support_div"
            style={{
              maxHeight: "85vh",
              overflow: "auto",
              marginTop: "10px",
              scrollbarWidth: "none"
            }}>
            <InfiniteScroll
              scrollableTarget="support_div"
              dataLength={supportData?.length}
              next={() => getSupportData(pageNo)}
              hasMore={hasMore}
              loader={<Loader />}>
              {supportData?.map((data, index) => (
                <CustomListing key={index} index={index} data={data} />
              ))}
            </InfiniteScroll>
          </div>
        ) : (
          <Stack
            sx={{
              height: "85vh",
              alignItems: "center",
              justifyContent: "center"
            }}>
            <Typography>{TEXT_SEARCH_NO_SUPPORT_REQUESTS_PLACE_HOLDER}</Typography>
          </Stack>
        )}
      </Box>
      {viewSupport && (
        <ViewClientSupport
          open={viewSupport}
          handleClose={handleHideViewModel}
          supportId={supportId}
          custom={custom}
          setLoadNew={setLoadNew}
        />
      )}
      {viewAddModel && (
        <AddClientSupport
          open={viewAddModel}
          handleClose={handleToggleAddModel}
          setLoadNew={setLoadNew}
        />
      )}
      <div className="button-div">
        <IconButton
          className="icon-button"
          sx={{ backgroundColor: selectedClientData?.AccentColor }}
          onClick={handleToggleAddModel}>
          <AddIcon className="add-icon" />
        </IconButton>
      </div>
    </>
  );
}

export default ClientSupport;
